import { Component, OnInit } from '@angular/core';

import { User } from '../user';
import { SessionService } from '../session';
import { DialogService } from '../ui';
import { isSLFeatureEnabled } from '../shares-ledger';
import { isDLFeatureEnabled } from '../documents-ledger';

@Component({
  selector: 't-main-menu',
  templateUrl: './main-menu.component.html',
})
export class MainMenuComponent implements OnInit {
  isOpen = false;

  isSLFeatureEnabled: boolean = isSLFeatureEnabled();
  isDLFeatureEnabled: boolean = isDLFeatureEnabled();

  currentUser: User

  constructor(
    private sessionService: SessionService,
    private dialogService: DialogService)
  { }

  ngOnInit(): void {
    this.sessionService.currentUser.subscribe((user) => {
      this.currentUser = user;
    });
  }

  toggle() {
    this.isOpen = !this.isOpen;
  }

  close() {
    this.isOpen = false;
  }

  logout() {
    this.dialogService
      .confirm({
        title: 'Déconnexion',
        message: 'Voulez-vous fermer votre session ?',
        confirm_button_text: 'Déconnecter',
        confirm_button_class: 'btn-primary'
      }).subscribe((result) => {
        if (result) {
          this.sessionService.logout().subscribe(() => {
            window.location.href = '/';
          });
        }
      });
  }
}